import { Button, Card, CardContent, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PatButtons from '../components/PatButtons';
import { getAccountDetailsById } from 'app/api-ws/accounts-ws';
import AccountsForm from '../patientForms/AccountsForm';
import ReactPdf from 'app/pdf/ReactPdf';
import useAuth from 'app/hooks/useAuth';
import AccountsTable from '../components/AccountsTable';
import AddIcon from '@mui/icons-material/Receipt';

function PatientAccounts() {
  const { patientId, user } = useAuth();
  const [invoiceDialog, setInvoiceDialog] = useState(false);
  const [accountData, setAccountData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    fetchAccountsById();
  }, []);

  const fetchAccountsById = () => {
    getAccountDetailsById(patientId ? patientId._id : user?.selectedPatientId, user?.authToken)
      .then((res) => {
        console.log('res state:', res.data.data);
        setAccountData(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpenInvoiceDialog = () => {
    setInvoiceDialog(true);
  };

  const handleInvoiceDialogClose = () => {
    setInvoiceDialog(false);
  };

  // const handleOpenDialog = () => {
  //   setOpenDialog(true);
  // };
  // const handleCloseDialog = () => {
  //   setOpenDialog(false);
  //   fetchAccountsById();
  // };
  // const handleDialogSubmit = (values) => {
  //   console.log('Dialog form values:', values);

  //   handleCloseDialog();
  // };

  return (
    <>
      <Dialog maxWidth="md" open={invoiceDialog} onClose={handleInvoiceDialogClose}>
        <DialogContent>
          <ReactPdf
            selectedItems={selectedItems}
            handleInvoiceDialogClose={handleInvoiceDialogClose}
          />
        </DialogContent>
      </Dialog>
      <div style={{ backgroundColor: '#f3f3f3', height: '100%', display: 'flex', flex: 1 }}>
        <Grid container spacing={2} style={{ marginTop: '10px', padding: '10px' }}>
          <PatButtons />
          <Grid item xs={12} sm={6} md={8} lg={9}>
            <Card style={{ padding: '10px' }}>
              <CardContent>
                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <h2>Accounts Details</h2>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ height: 1 }}
                    onClick={() => handleOpenInvoiceDialog()}
                    style={{ backgroundColor: '#66b5a3', color: 'white' }}
                    startIcon={<AddIcon />}
                  >
                    Generate Invoice
                  </Button>
                  {/* <Button
                  variant="contained"
                  color="primary"
                  sx={{ height: 1 }}
                  onClick={() => handleOpenDialog()}
                  style={{ backgroundColor: '#66b5a3', color: 'white' }}
                  startIcon={<AddIcon />}
                >
                  Add Accounts
                </Button> */}
                  {/* <Dialog open={openDialog} onClose={handleDialogSubmit}>
                  <DialogTitle>Account</DialogTitle>
                  <DialogContent>
                    <AccountsForm handleCloseDialog={handleCloseDialog} patientId={patientId} />
                  </DialogContent>
                </Dialog> */}
                </Grid>
                <AccountsTable
                  accountData={accountData}
                  fetchAccountsById={fetchAccountsById}
                  selectedItems={selectedItems}
                  setSelectedItems={setSelectedItems}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default PatientAccounts;
